import { render } from "./onlinePrintSet.vue?vue&type=template&id=2d480270"
import script from "./onlinePrintSet.vue?vue&type=script&lang=js"
export * from "./onlinePrintSet.vue?vue&type=script&lang=js"

import "./onlinePrintSet.vue?vue&type=style&index=0&id=2d480270&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__